import React from 'react';
interface EqualizerProps {
  color?: string;
  count?: number;
  height?: string;
  className?: string;
}
export function Equalizer({
  color = 'bg-neon-cyan',
  count = 5,
  height = 'h-16',
  className = ''
}: EqualizerProps) {
  return <div className={`flex items-end gap-1 ${height} ${className}`} data-id="element-214">
      {Array.from({
      length: count
    }).map((_, i) => <div key={i} className={`w-2 md:w-3 rounded-t-sm equalizer-bar ${color}`} style={{
      animationDuration: `${0.4 + Math.random() * 0.8}s`,
      animationDelay: `${Math.random() * 0.5}s`
    }} data-id="element-215" />)}
    </div>;
}